export default {"src":"/_next/static/media/edit-pen.d0cbb91c.svg","height":36,"width":36};